import { render, staticRenderFns } from "./BlocksBiolinkConfig.vue?vue&type=template&id=e29c7c48&scoped=true"
import script from "./BlocksBiolinkConfig.vue?vue&type=script&lang=js"
export * from "./BlocksBiolinkConfig.vue?vue&type=script&lang=js"
import style0 from "./BlocksBiolinkConfig.vue?vue&type=style&index=0&id=e29c7c48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29c7c48",
  null
  
)

export default component.exports